import React from 'react'
import { IoClose } from 'react-icons/io5'
import AdminCustomButton from './AdminCustomButton'
import MessageBox from './MessageBox'
import MessageHeading from './MessageHeading'
import MessageLabel from './MessageLabel'


const AdminInfoBox = ({ modelClose, closeAction, confirmAction, hideCloseBtn, confirmText, heading, message }) => {
    return (
        <div class={`modal packageModel  fade ${modelClose && 'd-flex align-items-center show'}`} id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog w-50" role="document">
                <div className="modal-content rounded-5  theme-bg-color border-0 p-3 ">
                    {/* <div className="modal-header theme-border-bottom-secondary">
                        <MessageBox text={heading} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                        {!hideCloseBtn && <button type="button" className='bg-transparent' onClick={() => closeAction()} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>}
                    </div> */}
                    <div className="modal-body ">
                        <MessageHeading className="theme-text-color text-center" text={heading} padding border />
                        <MessageLabel text={message} className='text-center d-block' />
                    </div>
                    <div className="modal-footer  border-0">
                        {!hideCloseBtn && <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={() => closeAction()} ><MessageBox text="Cancel" /> </button>}
                        <AdminCustomButton className='px-3 py-1 m-0 ' saveMethod={confirmAction} saveText={confirmText} ></AdminCustomButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminInfoBox